import { render, staticRenderFns } from "./ConsignmentTable.vue?vue&type=template&id=44a3ddc6&scoped=true"
import script from "./ConsignmentTable.vue?vue&type=script&lang=ts"
export * from "./ConsignmentTable.vue?vue&type=script&lang=ts"
import style0 from "./ConsignmentTable.vue?vue&type=style&index=0&id=44a3ddc6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a3ddc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44a3ddc6')) {
      api.createRecord('44a3ddc6', component.options)
    } else {
      api.reload('44a3ddc6', component.options)
    }
    module.hot.accept("./ConsignmentTable.vue?vue&type=template&id=44a3ddc6&scoped=true", function () {
      api.rerender('44a3ddc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/consignment/ConsignmentTable.vue"
export default component.exports